/*
* Floating Label jQuery Plugin
* Adds floating label behavior to form fields
*/

(function($) {
  $.fn.FloatingLabel = function() {
    let $field = this
    let $input = $field.find('input, textarea, select')
    let $label = $field.find('label')

    function checkValue() {
      if ($input.val() && $input.val().length > 0) {
        $field.addClass('field--has-value field--populated')
      } else {
        $field.removeClass('field--has-value field--populated')
      }
    }

    $input.on('focus', function() {
      $field.addClass('field--focused')
    })

    $input.on('blur', function() {
      $field.removeClass('field--focused')
      checkValue()
    })

    $input.on('input change', checkValue)
    checkValue()

    return $field
  }
})(jQuery)
